import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getEndPoint } from "../../Utils/network.client";
import { IIndentRawData } from "../../features/indents/mainabstract";
type Params = {
  date: string,
  shiftId: number
}
const url = getEndPoint(API_END_POINT.REPORT) +"/api/TotalAbstract/GetTotalAbstractByDateShift";
export const useGetPrepareIndent = createQuery<
  IIndentRawData,
  Params,
  AxiosError
>({
  queryKey: ["keyIndendPreparations"],
  fetcher: (params) =>
    axios.get(url + "/" + params?.date+"/" + params?.shiftId , {}).then((response) => response?.data  || []),
    refetchOnWindowFocus: false,
});
